var map = {
	"./abkhazia.svg": "b4dc",
	"./afghanistan.svg": "2303",
	"./aland-islands.svg": "24b9",
	"./albania.svg": "969b",
	"./algeria.svg": "3a74",
	"./american-samoa.svg": "df57",
	"./andorra.svg": "cfd6",
	"./angola.svg": "b6f8",
	"./anguilla.svg": "2484",
	"./antigua-and-barbuda.svg": "fe3c",
	"./argentina.svg": "b257",
	"./armenia.svg": "5931",
	"./aruba.svg": "ca0d",
	"./australia.svg": "c29f",
	"./austria.svg": "6beb",
	"./azerbaijan.svg": "c00f",
	"./azores-islands.svg": "ebb9",
	"./bahamas.svg": "28de",
	"./bahrain.svg": "349d",
	"./balearic-islands.svg": "1b16",
	"./bangladesh.svg": "3537",
	"./barbados.svg": "5574",
	"./basque-country.svg": "f49e",
	"./belarus.svg": "56b6",
	"./belgium.svg": "c052",
	"./belize.svg": "6027",
	"./benin.svg": "96d6",
	"./bermuda.svg": "d2f8",
	"./bhutan-1.svg": "7d5b",
	"./bhutan.svg": "b173",
	"./bolivia-(plurinational-state-of).svg": "4a41",
	"./bolivia.svg": "9a24",
	"./bonaire,-sint-eustatius-and-saba.svg": "041a",
	"./bonaire.svg": "3fbe",
	"./bosnia-and-herzegovina.svg": "ae02",
	"./botswana.svg": "7fab",
	"./brazil.svg": "fddc",
	"./british-columbia.svg": "0988",
	"./british-indian-ocean-territory.svg": "b60a",
	"./british-virgin-islands.svg": "4f0e",
	"./brunei-darussalam.svg": "bf1f",
	"./brunei.svg": "e0c6",
	"./bulgaria.svg": "34fc",
	"./burkina-faso.svg": "144d",
	"./burundi.svg": "6a10",
	"./cabo-verde.svg": "8966",
	"./cambodia.svg": "ea0d",
	"./cameroon.svg": "268f",
	"./canada.svg": "2e8d",
	"./canary-islands.svg": "654e",
	"./cape-verde.svg": "85b4",
	"./cayman-islands.svg": "d515",
	"./central-african-republic.svg": "5873",
	"./ceuta.svg": "b7d2",
	"./chad.svg": "09f0",
	"./chile.svg": "6aff",
	"./china.svg": "36ed",
	"./christmas-island.svg": "283f",
	"./cocos-island.svg": "5763",
	"./colombia.svg": "a33f",
	"./comoros.svg": "2c25",
	"./congo,-democratic-republic-of-the.svg": "c734",
	"./congo.svg": "258f",
	"./cook-islands.svg": "e08e",
	"./corsica.svg": "a366",
	"./costa-rica.svg": "fa60",
	"./croatia.svg": "8e48",
	"./cuba.svg": "5296",
	"./curacao.svg": "95f5",
	"./curaçao.svg": "fb60",
	"./cyprus.svg": "c8f4",
	"./czech-republic.svg": "55b0",
	"./czechia.svg": "d645",
	"./côte-d'ivoire.svg": "79b6",
	"./default.svg": "8c18",
	"./democratic-republic-of-congo.svg": "2bf0",
	"./denmark.svg": "480e",
	"./djibouti.svg": "29b0",
	"./dominica.svg": "cb7b",
	"./dominican-republic.svg": "1b3d",
	"./east-timor.svg": "bc69",
	"./ecuador.svg": "6d53",
	"./egypt.svg": "8461",
	"./el-salvador.svg": "d679",
	"./england.svg": "31dc",
	"./equatorial-guinea.svg": "1814",
	"./eritrea.svg": "db94",
	"./estonia.svg": "c11b",
	"./eswatini.svg": "3606",
	"./ethiopia.svg": "3517",
	"./european-union.svg": "b8d2",
	"./falkland-islands.svg": "9d49",
	"./faroe-islands.svg": "e1e9",
	"./fiji.svg": "a7ef",
	"./finland.svg": "9a62",
	"./france.svg": "8ec4",
	"./french-guiana.svg": "b188",
	"./french-polynesia.svg": "1b81",
	"./french-southern-territories.svg": "395a",
	"./gabon.svg": "7051",
	"./galapagos-islands.svg": "deba",
	"./gambia.svg": "fad8",
	"./georgia.svg": "17f7",
	"./germany.svg": "57a6",
	"./ghana.svg": "4b65",
	"./gibraltar.svg": "035c",
	"./greece.svg": "abd4",
	"./greenland.svg": "b297",
	"./grenada.svg": "92a5",
	"./guadeloupe.svg": "005c",
	"./guam.svg": "b463",
	"./guatemala.svg": "6e45",
	"./guernsey.svg": "9eec",
	"./guinea-bissau.svg": "d82a",
	"./guinea.svg": "97fe",
	"./guyana.svg": "c56a",
	"./haiti.svg": "7c0e",
	"./hawaii.svg": "4f4d",
	"./honduras.svg": "4177",
	"./hong-kong.svg": "2652",
	"./hungary.svg": "050d",
	"./iceland.svg": "7eb9",
	"./india.svg": "8e34",
	"./indonesia.svg": "c60b",
	"./iran.svg": "8106",
	"./iraq.svg": "db7c",
	"./ireland.svg": "9a12",
	"./isle-of-man.svg": "29cf",
	"./israel.svg": "98f0",
	"./italy.svg": "8f6c",
	"./ivory-coast.svg": "5f83",
	"./jamaica.svg": "1daa",
	"./japan.svg": "2c1f",
	"./jersey.svg": "b03f",
	"./jordan.svg": "8c6d",
	"./kazakhstan.svg": "c638",
	"./kenya.svg": "d1f3",
	"./kiribati.svg": "93eb",
	"./korea.svg": "3331",
	"./kosovo.svg": "f1bb",
	"./kuwait.svg": "9fd1",
	"./kyrgyzstan.svg": "f4f5",
	"./lao-people's-democratic-republic.svg": "5751",
	"./laos.svg": "951b",
	"./latvia.svg": "ae6a",
	"./lebanon.svg": "5e12",
	"./lesotho.svg": "bd1e",
	"./liberia.svg": "e07c",
	"./libya.svg": "c8c0",
	"./liechtenstein.svg": "6029",
	"./lithuania.svg": "3be7",
	"./luxembourg.svg": "2499",
	"./macao.svg": "8ed6",
	"./madagascar.svg": "0b01",
	"./madeira.svg": "32c2",
	"./malawi.svg": "cfe5",
	"./malaysia.svg": "99fc",
	"./maldives.svg": "6fdd",
	"./mali.svg": "d2d9",
	"./malta.svg": "04fd",
	"./marshall-island.svg": "7b04",
	"./martinique.svg": "5de1",
	"./mauritania.svg": "9090",
	"./mauritius.svg": "dc39",
	"./mayotte.svg": "e4e7",
	"./melilla.svg": "1acb",
	"./mexico.svg": "c07b",
	"./micronesia-(federated-states-of).svg": "ccfd",
	"./micronesia.svg": "8e00",
	"./moldova.svg": "1a86",
	"./monaco.svg": "a6dc",
	"./mongolia.svg": "deb7",
	"./montenegro.svg": "19dc",
	"./montserrat.svg": "3a7bd",
	"./morocco.svg": "19fa",
	"./mozambique.svg": "351d",
	"./myanmar.svg": "994c",
	"./namibia.svg": "ccd0",
	"./nato.svg": "de13",
	"./nauru.svg": "7653",
	"./nepal.svg": "a05a",
	"./netherlands.svg": "c7a1",
	"./new-caledonia.svg": "edb5",
	"./new-zealand.svg": "fbc8",
	"./nicaragua.svg": "337b",
	"./niger.svg": "d9fa",
	"./nigeria.svg": "2299",
	"./niue.svg": "da30",
	"./no-name.svg": "2f7c",
	"./norfolk-island.svg": "bd48",
	"./north-korea.svg": "a17b",
	"./north-macedonia.svg": "417d",
	"./northen-cyprus.svg": "4a6b",
	"./northern-marianas-islands.svg": "e5de",
	"./norway.svg": "134e",
	"./oman.svg": "2847",
	"./orkney-islands.svg": "913c",
	"./ossetia.svg": "0059",
	"./pakistan.svg": "62cd",
	"./palau.svg": "57634",
	"./palestine,-state-of.svg": "f530",
	"./palestine.svg": "2a2e",
	"./panama.svg": "41d9",
	"./papua-new-guinea.svg": "fed3",
	"./paraguay.svg": "0392",
	"./peru.svg": "b183",
	"./philippines.svg": "1240",
	"./pitcairn-islands.svg": "f69b",
	"./poland.svg": "d29d",
	"./portugal.svg": "ee25",
	"./puerto-rico.svg": "c110",
	"./qatar.svg": "b705",
	"./rapa-nui.svg": "33c5",
	"./republic-of-macedonia.svg": "c981",
	"./republic-of-poland.svg": "1be0",
	"./romania.svg": "d181",
	"./russia.svg": "0307",
	"./russian-federation.svg": "43ad",
	"./rwanda.svg": "098e",
	"./réunion.svg": "bea3",
	"./saba-island.svg": "cb00",
	"./saint-barthélemy.svg": "d29f",
	"./saint-kitts-and-nevis.svg": "6542",
	"./saint-lucia.svg": "7495",
	"./saint-martin.svg": "9363",
	"./saint-pierre-and-miquelon.svg": "9874",
	"./salvador.svg": "5c19",
	"./samoa.svg": "9414",
	"./san-marino.svg": "f340",
	"./sao-tome-and-principe.svg": "3f2f",
	"./sardinia.svg": "5c28",
	"./saudi-arabia.svg": "d2d7",
	"./scotland.svg": "2730",
	"./senegal.svg": "5977",
	"./serbia.svg": "87ee",
	"./seychelles.svg": "5036",
	"./sierra-leone.svg": "5d46",
	"./singapore.svg": "ac50",
	"./sint-eustatius.svg": "89e7",
	"./sint-maarten-(dutch-part).svg": "18d6",
	"./sint-maarten.svg": "b0ed",
	"./slovakia.svg": "b2ce",
	"./slovenia.svg": "f2ae",
	"./solomon-islands.svg": "a16a",
	"./somalia.svg": "1ca5",
	"./somaliland.svg": "e423",
	"./south-africa.svg": "ae06",
	"./south-korea.svg": "c6fc",
	"./south-sudan.svg": "6641",
	"./spain.svg": "703c",
	"./sri-lanka.svg": "37a6",
	"./st-barts.svg": "d66c",
	"./st-lucia.svg": "0176",
	"./st-vincent-and-the-grenadines.svg": "0ee3",
	"./sudan.svg": "7bfc",
	"./suriname.svg": "cc5c",
	"./swaziland.svg": "6e79",
	"./sweden.svg": "6c4d",
	"./switzerland.svg": "c796",
	"./syria.svg": "5eaf",
	"./taiwan,-province-of-china.svg": "173b",
	"./taiwan.svg": "de18",
	"./tajikistan.svg": "f207",
	"./tanzania,-united-republic-of.svg": "a441",
	"./tanzania.svg": "3a8c",
	"./thailand.svg": "81a7",
	"./tibet.svg": "8a9c",
	"./togo.svg": "5242",
	"./tokelau.svg": "e9e2",
	"./tonga.svg": "3e52",
	"./transnistria.svg": "66b4",
	"./trinidad-and-tobago.svg": "1ea9",
	"./tunisia.svg": "eafb",
	"./turkey.svg": "47d8",
	"./turkmenistan.svg": "068b",
	"./turks-and-caicos-islands.svg": "e85d",
	"./turks-and-caicos.svg": "3cea",
	"./tuvalu.svg": "db5b",
	"./uganda.svg": "a3c1",
	"./ukraine.svg": "1228",
	"./united-arab-emirates.svg": "94ba",
	"./united-kingdom.svg": "1791",
	"./united-nations.svg": "2a24",
	"./united-states-of-america.svg": "96b7",
	"./uruguay.svg": "bebb",
	"./uzbekistan.svg": "9c4b",
	"./uzbekistn.svg": "0665",
	"./vanuatu.svg": "2eea",
	"./vatican-city.svg": "e737",
	"./venezuela-(bolivarian-republic-of).svg": "6734",
	"./venezuela.svg": "f6e3",
	"./viet-nam.svg": "695d",
	"./vietnam.svg": "c69a",
	"./virgin-islands.svg": "dddf",
	"./wales.svg": "585b",
	"./wallis-and-futuna.svg": "082b",
	"./western-sahara.svg": "4938",
	"./yemen.svg": "189c",
	"./zambia.svg": "6ad1",
	"./zimbabwe.svg": "4805"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "5ba2";